import { Button, Input } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FiSearch } from 'react-icons/fi'
import { useSearchParams } from 'react-router-dom'
import { FilterPopover } from '@/shared/components/filter-popover'
import DebouncedInput from '@/shared/components/debounced-input';
import { ContractSelector, StatusSelector } from '@/shared/selectors'

export const OfficesFilter = () => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const handleFilterChange = (name, value) => {
    if (value === '' || value === null || value === undefined) {
      searchParams.delete(name);
    } else {
      searchParams.set(name, value);
      searchParams.set('page', 1);
    }
    setSearchParams(searchParams)
  };

  const handleInputSearch = (value) => {
    handleFilterChange('q', value);
  }
  
  const cleanSearchParams = () => {
    searchParams.delete('q')
    searchParams.delete('by_status')
    setSearchParams(searchParams)

    setSearchParams(prevParams => new URLSearchParams(prevParams))
  }
  
  return (
    <div className='flex gap gap-3'>
      <div>
        <DebouncedInput
          name='q'
          icon={<FiSearch />}
          label={t('office.searcher.label')}
          onChange={handleInputSearch}
          value={searchParams.get('q') || ''}
          className='w-full sm:w-80'
        />
      </div>
      <FilterPopover>
        <div className='grid gap gap-4'>
          <div className='grid gap gap-2'>
            <StatusSelector
              onChange={({ value }) =>
                handleFilterChange('by_status', value)
              }
              value={searchParams.get('by_status') || null}
            />
          </div>
          <div className='flex justify-center mt-10'>
            <Button
              type='button'
              className='bg-color-white text-red-600 border-solid border-2 border-red-200 p-2'
              onClick={cleanSearchParams}
            >
              {t('filters.delete')}
            </Button>
          </div>
        </div>
      </FilterPopover>
    </div>
  )
}

OfficesFilter.propTypes = {
  open: PropTypes.bool,
  handler: PropTypes.func
}
